import { t_dataName } from 'src/app/services/apiHandler/basicMachineFunctions/basic-machine-functions.service';

export type t_EquipmentPressureDataPoint = {
    generalName: string;
    dataName: t_dataName;
    unit: string;
    value?: number;
    position: e_Positions;
};

export type t_EquipmentPressureDataset = {
    dataPoints: t_EquipmentPressureDataPoint[];
};

export enum e_Positions {
    Connection_Upper_Undercarriage,
    Undercarriage, //Machine
    Main_Uppercarriage,
    Boom_Cylinder,
    Stick_Cylinder,
    Tool,
    Position,
    Pressure
}

export var initEquipmentCurrentDataset: t_EquipmentPressureDataset = {
    dataPoints: [
        {
            generalName: 'DATANAMES.PRESSURE.DRIVE',
            dataName: {
                name: 'PressureDrive',
            },
            unit: 'bar',
            position: e_Positions.Pressure,
        },
        {
            generalName: 'DATANAMES.PRESSURE.STEERING',
            dataName: {
                name: 'PressureSteering',
            },
            unit: 'bar',
            position: e_Positions.Pressure,
        },
        {
            generalName: 'DATANAMES.PRESSURE.TELE',
            dataName: {
                name: 'TeleBoomControlTelePressureExtendFiltered',
            },
            unit: 'bar',
            position: e_Positions.Pressure,
        },
        {
            generalName: 'DATANAMES.POSITION.CABINE',
            dataName: {
                name: 'CabineHoistLowerAngle',
            },
            unit: 'bar',
            position: e_Positions.Position,
        },
        {
            generalName: 'DATANAMES.POSITION.FORK',
            dataName: {
                name: 'ForkAngle',
            },
            unit: 'bar',
            position: e_Positions.Position,
        },
    ],
};